import actionTypes from '../../actions/dictionaries/dictionaries.action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PACK_STATUSES_DICTIONARY_SUCCESS:
      return { ...action.packStatuses };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/modules/app/reducers/dictionaries/pack-statuses-dictionary.js